import React, { ChangeEvent, KeyboardEvent, useEffect, useRef } from 'react';
import { ResizableInput } from 'shared/components/ui/resizable-input';

import * as Styled from './reminders-popup-menu.style';

export type ReminderTimeInputRowProps = {
  label: string;
  placeholder: string;
  value: string;
  hasError?: boolean;
  onChange: (value: string) => void;
  onSubmit: () => void;
};

export const ReminderTimeInputRow: React.FC<ReminderTimeInputRowProps> = ({
  label,
  placeholder,
  value,
  hasError,
  onChange,
  onSubmit,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const _onChange = ({ target }: ChangeEvent<HTMLInputElement>) =>
    onChange(target.value);

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== 'Enter') {
      return;
    }

    e.preventDefault();
    onSubmit();
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <Styled.InputRow>
      <Styled.InputText $isError={hasError}>{label}</Styled.InputText>
      <ResizableInput
        ref={inputRef}
        placeholder={placeholder}
        value={value}
        onChange={_onChange}
        onKeyDown={onKeyDown}
        showAsSmallFormInput
      />
    </Styled.InputRow>
  );
};
